import { fetchTimeInterval, getCurrentTime, isSet, optionsToKeyValuePairs } from "../../../../../../utils/commonUtils";
import { computationRules1 } from "./DrugScreenCollection";
import { tbRiskQuestions, tbSymptomQuestions } from "./tbBloodQuestionnaire";

const stackedFieldStyle = {
  layout: 'stacked',
  showContainerBorder: false,
  labelWrap: false,
  isLabel: true,
};

// Chart config for TB Assessment
export const TBSkinAssessment = (props) => {
const tabData = {
  type: 'Tab',
  col: 'col-md-9',
  data: [
    {
      id: 'History1',
      label: 'History',
      labelStyle: { padding: 0 },
      data: [
        {
          label: 'Tuberculosis Risk Questionnaire',
          hideHeader: true,
          cardBodyClassName: 'p-0',
          fields: [
            {
              type: 'NewYesOrNoFields',
              label: 'Tuberculosis Risk Questionnaire',
              col: 'col-12',
              options: [{ label: 'Yes', value: 1 }, { label: 'No', value: 0 }],
              defaultValues: tbRiskQuestions.reduce((acc, itm) => {
                acc[itm.name] = 0;
                return acc;
              }, {}),
              list: tbRiskQuestions
            }
          ]
        },
        {
          label: 'Tuberculosis Symptom Questionnaire',
          hideHeader: true,
          cardBodyClassName: 'p-0',
          fields: [
            // {
            //   label: "Do you currently have any of the following symptoms?",
            //   col: "col-12",
            //   type: "Label",
            //   labelWrap: false,
            // },
            {
              type: 'NewYesOrNoFields',
              label: 'Tuberculosis Symptom Questionnaire ',
              subLabel: 'Do you currently have any of the following symptoms?',
              sublabelStyle: 'text-left text-black text-md fw-bold opacity-100',
              col: 'col-12',
              options: [{ label: 'Yes', value: 1 }, { label: 'No', value: 0 }],
              defaultValues: tbSymptomQuestions.reduce((acc, itm) => {
                acc[itm.name] = 0;
                return acc;
              }, {}),
              list: tbSymptomQuestions
            }
          ]
        },
        {
          label: 'Patient Signature & Comments',
          labelStyle: "fw-semibold pl-2",
          col: 'col-12',
          fields: [
            {
              label: 'Comments',
              type: 'TextArea',
              name: 'tb_comments',
              id: 'tb_comments',
              col: 'col-md-6 col-12 border-0',
              layout: 'stacked',
              labelStyle: { paddingLeft: '0.75rem' },
              style: { minHeight: '150px', resize: 'vertical' },
              rows: 5,
              placeholder: "Content",
            },
            {
              label: "Signature",
              type: 'NewSignature',
              isLabel: false,
              col: 'col-md-6 col-12 border-0',
              name: 'tb_patient_signature',
              id: 'tb_patient_signature',
            },
          ]
        },
      ]
    },
    {
      id: 'SkinTest',
      label: 'Skin Test',
      labelStyle: { padding: 0 },
      data: [
        {
          label: 'Skin Test',
          labelStyle: 'fw-semibold pl-2',
          fieldProps: stackedFieldStyle,
          fields: [
            {
              label: "Step One",
              type: "Label",
              layout: 'stacked',
              col: 'col-12 border-0 ',
              name: "step_one",
              id: 'step_one',
              isBold:true,
              fontBold:'400',
              appendClassLabel:'text-left text-black text-md fw-bold opacity-100 pl-2',
            },
            {
              label: 'Date Placed',
              type: 'Date',
              name: 'skin_test_date_placed',
              id: 'skin_test_date_placed',
              col: 'col-md-6 col-12',
              placeholder: 'MM / DD / YYYY',
            },
            {
              label: 'Time',
              isAsync: true,
              type: "SelectSearchList",
              name: 'skin_test_time',
              id: 'skin_test_time',
              col: 'col-md-6 col-12',
              placeholder: 'Content',
              className: "form-control form-control-solid",
              options: [
                { label: getCurrentTime(), value: getCurrentTime() },
              ],
              loadCallBack: (val, callback) =>
                fetchTimeInterval(val, callback),
            },
            {
              label: 'Location',
              type: 'radioBoxGroup',
              name: 'skin_test_location',
              id: 'skin_test_location',
              col: 'col-md-6 col-12',
              layout: 'stacked',
              options: [
                { label: 'Left', value: 'Left' },
                { label: 'Right', value: 'Right' },
              ],
            },
            {
              label: 'Manufacturer',
              type: 'TextInput',
              name: 'skin_test_manufacturer',
              id: 'skin_test_manufacturer',
              col: 'col-md-6 col-12',
              placeholder: 'Content',
            },
            {
              label: 'Lot Number',
              type: 'TextInput',
              name: 'skin_test_lot_number',
              id: 'skin_test_lot_number',
              col: 'col-md-6 col-12',
              placeholder: 'Content',
            },
            {
              label: 'Administered By',
              type: 'TextInput',
              name: 'skin_test_administered_by',
              id: 'skin_test_administered_by',
              col: 'col-md-6 col-12',
              placeholder: 'Content',
            },
            {
              label: "Step Two",
              type: "Label",
              layout: 'stacked',
              col: 'col-12 border-0 mt-2',
              name: "step_two",
              id: 'step_two',
              isBold:true,
              fontBold:'400',
              appendClassLabel:'text-left text-black text-md fw-bold opacity-100 pl-2',
            },
            {
              label: 'Date Read',
              type: 'Date',
              name: 'skin_test_date_read',
              id: 'skin_test_date_read',
              col: 'col-md-6 col-12',
              placeholder: 'MM / DD / YYYY',
            },
            {
              label: 'Read Time',
              isAsync: true,
              type: 'SelectSearchList',
              name: 'skin_test_read_time',
              id: 'skin_test_read_time',
              col: 'col-md-6 col-12',
              placeholder: 'Content',
              className: "form-control form-control-solid",
              options: [
                { label: getCurrentTime(), value: getCurrentTime() },
              ],
              loadCallBack: (val, callback) =>
                fetchTimeInterval(val, callback),
            },
           
            {
              label: 'Result',
              type: 'radioBoxGroup',
              layout: 'stacked',
              name: 'skin_test_result_status',
              id: 'skin_test_result_status',
              col: 'col-md-6 col-12',
              options: [
                { label: 'Negative', value: 'Negative' },
                { label: 'Positive (Need Chest X-ray)', value: 'Positive (Need Chest X-ray)' },
              ],
            },
            {
              label: 'Result Time',
              isAsync: true,
              type: 'SelectSearchList',
              name: 'skin_test_result',
              id: 'skin_test_result',
              col: 'col-md-6 col-12',
              placeholder: 'Content',
              className: "form-control form-control-solid",
              options: [
                { label: getCurrentTime(), value: getCurrentTime() },
              ],
              loadCallBack: (val, callback) =>
                fetchTimeInterval(val, callback),
            },
            {
              label: 'Read By',
              type: 'TextInput',
              name: 'skin_test_read_by',
              id: 'skin_test_read_by',
              col: 'col-md-6 col-12',
              placeholder: 'Content',
            },
          ]
        },
        {
          label: 'Chest X-Ray',
          labelStyle: 'fw-semibold pl-2',
          fieldProps: stackedFieldStyle,
          fields: [
            {
              label: "PA View (min req)",
              type: "Label",
              layout: 'stacked',
              col: 'col-12 border-0 ',
              name: "skin_test_chest_xray_pa_view",
              id: 'skin_test_chest_xray_pa_view',
              isBold:true,
              fontBold:'400',
              appendClassLabel:'text-left text-black text-md fw-bold opacity-100',
            },
            {
              label: 'Date',
              type: 'Date',
              name: 'skin_test_chest_xray_date',
              id: 'skin_test_chest_xray_date',
              col: 'col-6',
              placeholder: 'MM / DD / YYYY',
              layout: 'stacked',
            },
            {
              type: 'radioBoxGroup',
              label: 'Result',
              layout: 'stacked',
              isVertical: false,
              col: 'col-6',
              showContainerBorder: false,
              name:"skin_test_chest_xray_result",
              id:"skin_test_chest_xray_result",
              // combineToKey:"skin_test_chest_xray_result",
              options: [
                { value: 'Normal', label: 'Normal' },
                { value: 'Abnormal', label: 'Abnormal' },
              ],
            },
          ]
        },
        {
          label: 'Additional testing or follow up(Recommendations)',
          fieldProps: stackedFieldStyle,
          labelStyle: 'fw-semibold pl-2',
          fields: [
            {
              type: 'CheckBoxGroup',
              col: 'col-md-4',
              isLabel: false,
              isVertical: true,
              showContainerBorder: false,
              id:"skin_test_followup",
              name:"skin_test_followup",
              combineToKey:"skin_test_followup",
              options: [
                { name: 'Repeat skin test', label: 'Repeat skin test' },
                { name: 'Consult infectious disease', label: 'Consult infectious disease' },
                { name: 'Follow up occ health nurse', label: 'Follow up occ health nurse' },
                { name: 'Other', label: 'Other' },
              ]
            },
            {
              type: 'CheckBoxGroup',
              col: 'col-md-4',
              isLabel: false,
              isVertical: true,
              showContainerBorder: false,
              id:"skin_test_followup",
              name:"skin_test_followup",
              combineToKey:"skin_test_followup",
              options: [
                { name: 'Chest x-ray', label: 'Chest x-ray' },
                { name: 'Start prescription treatment', label: 'Start prescription treatment' },
                { name: 'None', label: 'None' },
              ]
            },
            {
              type: 'CheckBoxGroup',
              col: 'col-md-4',
              isLabel: false,
              isVertical: true,
              showContainerBorder: false,
              id:"skin_test_followup",
              name:"skin_test_followup",
              combineToKey:"skin_test_followup",
              options: [
                { name: 'Blood test', label: 'Blood test' },
                { name: 'Start preventative treatment', label: 'Start preventative treatment' },
              ]
            },
            {
              label: 'Content',
              type: 'TextArea',
              name: 'skin_test_followup_comment',
              id: 'skin_test_followup_comment',
              col: 'col-12',
              isLabel: false,
              placeholder: 'Content',
              rows: 3,
              disabled: true,
              rules: [
                { rule: [{ field: 'skin_test_followup', value: 'Other', operator: 'includes' }], action: 'ENABLE' },
                // { rule: [{ field: 'skin_test_followup', value: 'Other', operator: '!includes' }], action: 'CLEAR' }
              ],
            },
            
          ]
        },
        {
          label: 'Review / Completion',
          labelStyle: 'fw-semibold pl-2',
          fieldProps: stackedFieldStyle,
          fields: [
          {
              type: 'ProviderSignOff',
              col: 'col-12',
              fields: [
              { label: 'Signature PIN', name: 'provider_pin', col: 'col-12' },
              { label: 'Signature', type: 'NewSignature', name: 'provider_signature', col: 'col-12' },
              { label: 'Date', type: 'Date', name: 'signed_date', col: 'col-12' },
              // { label: 'Suggested Result', placeholder: 'Not Started', type: 'TextInput', name: 'suggested_status', col: 'col-6' },
              // Previous options:
              // { label: 'Final Results', type: 'SelectList', name: 'status', statusBasedColor:true, col: 'col-12', options: [] },
              // { label: 'Activity Status', type: 'SelectList', name: 'activity_status',  statusBasedColor:true, col: 'col-12', options: [] },
              // New standard options:
              { 
                label: 'Final Results',
                type: 'SelectList',
                name: 'status',
                statusBasedColor:true,
                col: 'col-12',
                options: optionsToKeyValuePairs(
                  [
                    "Not Started",
                    "Pending",
                    "Normal",
                    "Abnormal",
                    "Negative",
                    "Positive",
                    "Dispensed",
                    "Administered",
                    "Failed",
                    "Passed",
                    "Non-Negative",
                    "Cancelled",
                    "Inconclusive",
                  ],
                  false
                ),
              },
              { 
                label: 'Activity Status',
                type: 'SelectList',
                name: 'activity_status',
                statusBasedColor:true,
                col: 'col-12',
                options: optionsToKeyValuePairs(
                  [
                    "Not Started",
                    "Pending",
                    "Pending Lab Confirmation",
                    "Pending MRO Confirmation",
                    "Ready for Review",
                    "Completed",
                    "Cancelled",
                  ],
                  false
                ),
              },
              ],
          },
          ],
      },
      ]
    },
  ]
};

  // Update status dropdowns in Review/Completion section for both tabs
  const tabsToUpdate = ['Blooddraw', 'SkinTest'];
  tabsToUpdate.forEach(tabId => {
    const tab = tabData.data.find((t) => t.id === tabId);
    if (tab && tab.data) {
      const reviewSection = tab.data.find((s) => s.label === 'Review / Completion');
      if (reviewSection && reviewSection.fields && reviewSection.fields[0] && reviewSection.fields[0].fields) {
        const providerFields = reviewSection.fields[0].fields;
        const statusField = providerFields.find((f) => f.name === 'status');
        const activityStatusField = providerFields.find((f) => f.name === 'activity_status');

        // Previous options:
        // if (statusField) statusField.options = isSet(props.lookupsOptions?.['chartResult'], []);
        // if (activityStatusField) activityStatusField.options = optionsToKeyValuePairs(['Not Started', 'Ordered', 'Completed', 'Cancelled'],false);

        // New standard options:
        if (statusField) {
          statusField.options = optionsToKeyValuePairs(
            [
              "Not Started",
              "Pending",
              "Normal",
              "Abnormal",
              "Negative",
              "Positive",
              "Dispensed",
              "Administered",
              "Failed",
              "Passed",
              "Non-Negative",
              "Cancelled",
              "Inconclusive",
            ],
            false
          );
        }
        if (activityStatusField) {
          activityStatusField.options = optionsToKeyValuePairs(
            [
              "Not Started",
              "Pending",
              "Pending Lab Confirmation",
              "Pending MRO Confirmation",
              "Ready for Review",
              "Completed",
              "Cancelled",
            ],
            false
          );
        }
      }
    }
  });

  const charts = [
    {
      type: 'Grid',
      col: 'col-md-3',
      data: [
        { type: 'PatientDetails', employeeDetails: props.employeeDetails, visitDetails: props.visitDetails },
        { type: 'CompanyDetails', companyDetails: props.companyDetails },
      ],
    },
    tabData,
  ];

  const defaultValue = {
    // ...tbRiskQuestions.reduce((acc, itm) => {
    //   acc[itm.name] = 0;
    //   return acc;
    // }, {}),
    // ...tbSymptomQuestions.reduce((acc, itm) => {
    //   acc[itm.name] = 0;
    //   return acc;
    // }, {}),
    status: 'Not Started',
    activity_status: 'Not Started',
  };

  const headers = [];

  return {
    charts,
    defaultValue,
    headers,
    computationFunction: (formData, key) => computationRules1(formData, key),
    buttons: {
      PDF: true,
    },
  };
};
